import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import {mapQuizSessionWriteToDb} from './mapQuizSessionWriteToDb';
import {QuizSessionDb} from './quizSessionDbSchema';
import {QuizSession} from './quizSessionSchema';
import {quizSessionWriteSchema} from './quizSessionWriteSchema';

/**
 * Convert QuizSession to QuizSessionDb
 * @param session
 * @param timestamp
 * @returns
 */
export function mapQuizSessionTypeToDb(session: QuizSession, timestamp: FirestoreTimestamp): QuizSessionDb {
  return mapQuizSessionWriteToDb(quizSessionWriteSchema.strip().parse(session), timestamp);
}
